import React from 'react';
import { Card, CardTitle } from 'material-ui/Card';
import { List, ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import CustomerIcon from 'material-ui/svg-icons/social/person-add';
import LightBulbIcon from 'material-ui/svg-icons/action/lightbulb-outline';
const styles = {
    card: { borderLeft: 'solid 4px #4caf50', flex: 1, marginLeft: '1em' },
    icon: { float: 'right', width: 64, height: 64, padding: 16, color: '#4caf50' },
};

export default ({ visitors = [], nb }) => (
    <Card style={styles.card}>
        <CustomerIcon style={styles.icon} />
        <CardTitle title={nb} subtitle="New Customers" />
        <List>
            {visitors.map(record =>
                <ListItem href={`#/customers/${record.id}`} key={record.id} 
                leftAvatar={<Avatar backgroundColor="#FFEB3B" icon={<CustomerIcon />} />} >
                    {record.name_heb} {record.provider_number}
                </ListItem>
            )}
        </List>
    </Card>
);





// WEBPACK FOOTER //
// ./src/dashboard/NewCustomers.js